import { render, staticRenderFns } from "./AvisosAtivos.vue?vue&type=template&id=2aa12940&scoped=true"
import script from "./AvisosAtivos.vue?vue&type=script&lang=js"
export * from "./AvisosAtivos.vue?vue&type=script&lang=js"
import style0 from "./AvisosAtivos.vue?vue&type=style&index=0&id=2aa12940&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa12940",
  null
  
)

export default component.exports